import { PricePlanType } from '@systemeio/types'
import { PricePlanDetails } from 'modules/digital-product/price-plans/components/price-plan-details'
import React from 'react'
import { Tooltip } from 'shared/components'

interface PaymentTooltipProps {
  pricePlan: PricePlanType | null
  children: React.ReactNode
  productPriceAmount?: string
  customRow?: React.ReactNode
  hiddenInfo?: boolean
}

export const PricePlanTooltip = ({
  pricePlan,
  children,
  hiddenInfo,
  customRow,
  productPriceAmount,
}: PaymentTooltipProps) => {
  if (!pricePlan) {
    return <div>{children}</div>
  }

  return (
    <Tooltip
      mode="hover"
      label={
        <PricePlanDetails
          additionalRows={customRow}
          amountOverride={productPriceAmount}
          className="max-w-sm"
          hideOrderFormInfo={hiddenInfo}
          pricePlan={pricePlan}
          variant="rows"
        />
      }
      triggerProps={{ className: 'min-w-0' }}
    >
      {children}
    </Tooltip>
  )
}
